import React, { useState } from 'react'
import { Grid } from "@mui/material"
import styled from '@emotion/styled'

import AutoCompleteSolo from '../../../utils/utilities/AutoCompleteSolo';

import { useFormikContext } from 'formik';

// form context
import useRequestItems from '../../../hooks/useRequestItems';

import EditInventoryItem from '../../InventoryItem/EditInventory';

import InventoryItem from '../../../utils/utilities/WigComponents/InventoryItem';

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-top: 1.5rem;
`;

const RequestItems = () => {
  const { values } = useFormikContext() || {};
  const { formValues = {}, setFormValues, editItem, removeItem } = useRequestItems();

  const disabled = !values?.vendor_id

  const updates = ["inventory_item_id", "sku", "color", "length", "material", "cap_size", "hairstyle", "total_price", "length_unit", "brand_name", "line"];

  const update = {
    updates,
    updateFunc: setFormValues,
    arrToUpdate: "items"
  }

  return (
    <React.Fragment>
      <Grid size={{ xs: 12, md: 6 }}>
        <AutoCompleteSolo placeholder="Search Inventory Sku" fieldName="sku" useForm={true} FormComponent={<EditInventoryItem dialog={true}/>} update={update} disabled={disabled} conditionStr={`&vendor_id[$eq]=${values?.vendor_id}`} server={true} />
      </Grid>

      <Grid size={{ xs: 0, md: 6 }}>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <ItemList>
         {formValues.items.map((item, index) => <InventoryItem item={item} key={index} arr="items" removeItem={removeItem} editItem={editItem} />)}
        </ItemList>
      </Grid>
    </React.Fragment>
  )
}

export default RequestItems;